import React from "react";
import { useLocation } from "react-router";
import { RoutesPaths } from "../../Router/constant";
import { privacy, terms, termsOfAdvisoryPlan } from "../../constants";

export default function CopyrightFooter() {
  const currentYear = new Date().getFullYear();
  const location = useLocation();
  const ignoreCopyRight = [RoutesPaths.SUCCESS_SIGNNOW, RoutesPaths.E_SIGN, RoutesPaths.MESSAGE_DETAIL, RoutesPaths.ADMIN_LOGIN_VERIFICATION, RoutesPaths.INVITE_ACCEPT, RoutesPaths.PRODUCT_PAGE, RoutesPaths.DASHBOARD_PRODUCT_PAGE, RoutesPaths.BOOK_OF_BUSINESS_PRODUCT_PAGE]

  const validateShow = () => {
    // return !ignoreCopyRight.includes(location.pathname)
    return !ignoreCopyRight.some((path) => {
      if (path.includes(":")) {
        const basePath = path.split("/:")[0]; // Extract `/products` from `/products/:slug`
        const regex = new RegExp(`^${basePath}/[^/]+$`); // Ensures only one segment after `/products`
        return regex.test(location.pathname);
      }
      return location.pathname === path;
    });
  }

  return (
    <>
      {validateShow() && (
        <div className="container-fluid">
          <div className="row footerSection">
            <div className="col-md-6">
              <p className="m-0 footerLeftText">
                Copyright © {currentYear} InProved Pte Ltd
              </p>
              <p className="m-0 footerLeftText">
                (UEN 201616594C, PSPM license PS20190001819)
              </p>
            </div>
            <div className="col-md-6 linkSection">
              <div>
                <a
                  href={terms}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Terms and conditions
                </a>
              </div>
              <div>
                <a
                  href={privacy}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Privacy policy
                </a>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
